import Satellite from '../assets/Satellite.png';
import Terrain from '../assets/Terrain.png';
import Hybrid from '../assets/Hybrid.png';
import Roadmap from '../assets/Roadmap.png';

export const MAP_CONFIGS = [
  {
    name: 'Roadmap',
    mapId: '49ae42fed52588c3',
    mapTypeId: 'roadmap',
    image: Roadmap
  },
  {
    name: 'Satellite',
    mapId: '49ae42fed52588c3',
    mapTypeId: 'satellite',
    image: Satellite
  },
  {
    name: 'Hybrid',
    mapId: '49ae42fed52588c3',
    mapTypeId: 'hybrid',
    image: Hybrid
  },
  {
    name: 'Terrain',
    mapId: '49ae42fed52588c3',
    mapTypeId: 'terrain',
    image: Terrain
  }
];

export const INITAL_LAT_LNG = {
  lat: 37.49978719725259,
  lng: -96.31388772655319
};

export const DEFALUT_ZOOM = 4.9;

// The layer used until the user's saved preference (GET /userPreferences) loads.
export const DEFAULT_MAP_LAYER = MAP_CONFIGS[0].name;

// Maps a saved layer name (e.g. 'Satellite') to its MAP_CONFIGS index.
// Falls back to the first (Roadmap) layer for unknown/empty values.
export const layerNameToIndex = (name) => {
  const index = MAP_CONFIGS.findIndex(
    (config) => config.name?.toLowerCase() === String(name).toLowerCase()
  );
  return index === -1 ? 0 : index;
};

// Maps a MAP_CONFIGS index back to its layer name.
export const indexToLayerName = (index) =>
  MAP_CONFIGS[index]?.name ?? DEFAULT_MAP_LAYER;
